import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Component, effect, input, model, signal } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Menu } from "../menu/menu.component";
import { MenuOption } from "../menu/option/menu-option.component";
import { ClickOutside } from "ngxtension/click-outside";
import { BaseConfig } from "../common/config/config.adapter";
import { Label } from "../label/label.component";
import { Color, Colors } from "../common/types";

@Component({
  selector: "app-select-color",
  standalone: true,
  templateUrl: "./select-color.component.html",
  styleUrls: ["./select-color.component.scss"],
  imports: [MenuOption, Menu, Label, CommonModule, CdkMenuModule, ClickOutside],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectColor,
      multi: true,
    },
  ],
})
export class SelectColor extends BaseConfig implements ControlValueAccessor {
  label = input<string | null>("");
  value = model<Color>("primary");
  open = signal(false);

  colors = Colors;

  constructor() {
    super();

    effect(() => {
      this.onChange(this.value());
    });
  }

  writeValue(obj: any): void {
    this.open.set(false);
    this.value.set(obj);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {}

  onChange = (value: any) => {};
  onTouched = () => {};
}
